import React from "react"
import { logTool } from "@jsUtils"

import { CONSTANTS } from "@data"
import { Spotlight, Video, DropdownCopy, AudioContent } from "@components/sections"
import { ArticleImage, ContentCopy, Quote, HubSpotForm } from "@shared"
import { getType } from "@jsUtils/contentful"

const { CONTENT_TYPES } = CONSTANTS
const {
  COPY,
  QUOTE,
  IMAGE,
  SPOTLIGHT,
  VIDEO,
  DROPDOWN,
  AUDIO,
  FORM,
  TITLE,
  SUBTITLE
} = CONTENT_TYPES

const log = logTool()

/**
 * Render the component that corresponds to the content model type
 * @param {object} content - content object for contentfulArticle
 */
const resolveComponent = content => {
  log("Article/Bio/Event module:", content)

  let component = null

  // eslint-disable-next-line no-underscore-dangle
  switch (getType(content)) {
    case COPY:
      component = <ContentCopy data={content} key={content.id} />
      break
    case QUOTE:
      component = <Quote data={content} key={content.id} />
      break
    case IMAGE:
      component = <ArticleImage data={content} key={content.id} />
      break
    case SPOTLIGHT:
      component = <Spotlight data={content} key={content.id} />
      break
    case VIDEO:
      component = <Video data={content} key={content.id} />
      break
    case DROPDOWN:
      component = <DropdownCopy data={content} key={content.id} />
      break
    case AUDIO:
      component = <AudioContent data={content} key={content.id} />
      break
    case FORM:
      component = <HubSpotForm portalId={content?.portalId} formId={content?.formId} />
      break
    default:
      void 0
  }
  return component
}

export default resolveComponent
